import { GraphAction, GraphActionType } from '@spazious/dollhouse-shallow-graph';

export const stagingHashKeysFn = (action: GraphAction) =>
  `${action.type + Object.keys(action.payload)}`;

/**
 * Function to hash the staging action for reducing the number of updates
 */
export const stagingHashFn = (action: GraphAction) => {
  switch (action.type) {
    case GraphActionType.Remove:
      return `${stagingHashKeysFn(action)}${action.payload.selector}`;
    case GraphActionType.Update:
      return `${stagingHashKeysFn(action)}${action.payload.selector}${action.payload.path}`;
    default:
      return JSON.stringify(action);
  }
};
